import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    ReceiverPayloadT,
    ReceiversCreateReceiverResponseT,
    ReceiversGetListResponseT,
    ReceiversSearchParamT,
    ReceiversSearchReceiverResponseT,
} from '../types/receivers.types'
import { AdditionalServicesI, AdditionalServicesLTLI } from '@/core/types/additional_services.types'

export class ReceiversRepository {
    getList(
        page: number,
        sender_city_id: number,
        company_id: number
    ): Promise<AxiosResponse<ReceiversGetListResponseT>> {
        const params = {
            page_number: page,
            company_id,
        }

        return http.get(`/cabinet/api/receiver/${sender_city_id}`, { params })
    }

    getListWithoutCityId(
        page: number,
        company_id: number,
        city_id?: number
    ): Promise<AxiosResponse<ReceiversGetListResponseT>> {
        const params = {
            page_number: page,
            company_id,
            city_id,
        }

        return http.get('/cabinet/api/receiver', { params })
    }

    getListFtl(
        page: number,
        company_id: number,
        city_id?: number
    ): Promise<AxiosResponse<ReceiversGetListResponseT>> {
        const params = {
            page_number: page,
            company_id,
            city_id,
        }

        return http.get('/cabinet/api/receiver/ftl', { params })
    }

    createReceiver(
        payload: ReceiverPayloadT
    ): Promise<AxiosResponse<ReceiversCreateReceiverResponseT>> {
        return http.post('/cabinet/api/receiver', payload)
    }

    updateReceiver(
        id: number,
        payload: ReceiverPayloadT
    ): Promise<AxiosResponse<ReceiversCreateReceiverResponseT>> {
        return http.put(`/cabinet/api/receiver/${id}`, payload)
    }

    updateAdditionalServices(
        id: number,
        payload: AdditionalServicesLTLI
    ): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/additional-services/${id}`, payload)
    }

    updateReceiverInOrder(id: number, payload: ReceiverPayloadT): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/receivers/${id}`, payload)
    }

    deleteReceiver(id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/receiver/${id}`)
    }

    searchReceiver(
        params: ReceiversSearchParamT
    ): Promise<AxiosResponse<ReceiversSearchReceiverResponseT>> {
        return http.post('/cabinet/api/receiver/search', params)
    }
}
